import styled from 'styled-components';

export const BrandItem = styled.a<{ isCompact?: boolean }>`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: ${({ isCompact }) => (isCompact ? '0.25rem' : '1rem')};
`;

export const BrandItemLogo = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
